import { Component } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-benefit-pillars-select',
    templateUrl: './block-benefit-pillars-select.component.html',
    styleUrl: './block-benefit-pillars-select.component.scss',
    standalone: false,
})
export class BlockBenefitPillarsSelectComponent extends BlockAbstractComponent {
    parseImageUrl(url: string): string {
        return url.replace('/api/1.0/download', '/file');
    }
}
